import { MolsonBox } from '@components/reusable'
import { molsonStyled } from '@theme/customMuiExports'
export const StyledCustomFitContainer = molsonStyled(MolsonBox)({
  '& div:nth-of-type(1) > div:nth-of-type(1)': {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0
  },
  '& div:nth-of-type(2) > div:nth-of-type(1)': {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0
  },
  alignItems: 'center',
  display: 'flex'
})
